// components/settings/DangerZone.jsx
import { LogOut, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next"; // ← اضافه شده

const DangerZone = () => {
  const { t } = useTranslation(); // ← اضافه شده

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <section className="bg-white rounded-xl shadow p-4 space-y-4 border-t pt-4">
      <h2 className="text-lg font-semibold text-red-600">{t('danger_zone.title')}</h2>

      <button
        onClick={handleLogout}
        className="flex items-center gap-2 text-sm text-red-600 hover:text-red-700"
      >
        <LogOut size={16} />
        {t('danger_zone.logout_button')}
      </button>
    </section>
  );
};

export default DangerZone;